<img [src]="imgToUse().imgURL | srcSanitizer" class="img-responsive" alt="{{ image.label }}" (error)="onErrorFn()" *ngIf="isHidden">